import { Client } from './client';

export function createRsClient(endpoint, token) {
  return new Client(endpoint, token);
}

const rsclient = new Client();
export default rsclient;
